import { render, staticRenderFns } from "./MyAreas.vue?vue&type=template&id=51935aa8&scoped=true"
import script from "./MyAreas.vue?vue&type=script&lang=js"
export * from "./MyAreas.vue?vue&type=script&lang=js"
import style0 from "./MyAreas.vue?vue&type=style&index=0&id=51935aa8&prod&scoped=true&lang=css"
import style1 from "./MyAreas.vue?vue&type=style&index=1&id=51935aa8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51935aa8",
  null
  
)

export default component.exports